import type { IApiResponse } from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";

export const promocodesApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    // TODO: пока бэк незатипизировал success ответ.
    // если пришел redeemed (промокод активирован) - jwt для анонима
    // для рега пустой json
    redeem: build.mutation<IApiResponse<unknown>, { code: string }>({
      query({ code }) {
        return {
          url: "/foundation/api/promocodes/redeem",
          method: "POST",
          body: {
            code,
          },
        };
      },
      transformResponse: (response: IApiResponse<unknown>) => {
        return response;
      },
    }),
  }),
});
